import { Button } from '@helix-ds/react'
import React from 'react'

/**
 * Lightweight route for uptime checks; includes a Helix `Button` to validate DS wiring.
 */
export const HealthCheck: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white dark:bg-gray-900 p-6">
      <p className="text-base font-medium text-text-body dark:text-gray-400">Health check successful</p>
      <Button type="button">Helix OK</Button>
    </div>
  )
}
